module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid10_800x789.28cd8f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid10_800x789.jpg
// module id = Q4sf
// module chunks = 0